import React, { useEffect } from "react";
import { useFieldArray } from "react-hook-form";
import { TrashIcon } from "@heroicons/react/24/outline";
import classes from "./formDynamicStringList.module.css";

export const FormDynamicStringList = ({
  control,
  register,
  watch,
  fieldName,
  errors = {},
  disabled = false,
  value = [],
  onChange,
  required = false,
}) => {
  // Use RHF if control exists, else fallback to controlled mode
  const isRHF = !!control && !!register;

  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const values = isRHF ? watch(fieldName) || [] : value;

  // Ensure at least one input exists in RHF mode
  useEffect(() => {
    if (isRHF && fields.length === 0) {
      append("");
    }
  }, [fields, append, isRHF]);

  const handleAdd = () => {
    const lastValue = values[values.length - 1];
    if (!lastValue || lastValue.trim() === "") return;

    if (isRHF) {
      append("");
    } else {
      onChange([...values, ""]);
    }
  };

  const handleRemove = (index) => {
    if (values.length === 1) return;

    if (isRHF) {
      remove(index);
    } else {
      const newValues = [...values];
      newValues.splice(index, 1);
      onChange(newValues);
    }
  };

  const handleChange = (index, val) => {
    if (isRHF) return;
    const newValues = [...values];
    newValues[index] = val;
    onChange(newValues);
  };

  return (
    <div className={classes.wrapper}>
      {values.map((item, index) => {
        const fieldError = errors?.[fieldName]?.[index];
        return (
          <div className={classes.row} key={isRHF ? fields[index].id : index}>
            <div className={classes.inputBox}>
              <input
                type="text"
                placeholder=" "
                disabled={disabled}
                className={`${classes.input} ${
                  disabled ? classes.disabled : ""
                } ${fieldError ? classes.error : ""}`}
                {...(isRHF ? register(`${fieldName}.${index}`) : {})}
                value={isRHF ? undefined : item}
                onChange={isRHF ? undefined : (e) => handleChange(index, e.target.value)}
              />
              <label className={classes.floatingLabel}>
                Enter text
                {required && <span className={classes.asterisk}>*</span>}
              </label>

              {fieldError && (
                <div className={classes.errorIcon} title={fieldError.message}>
                  <TrashIcon className={classes.icon} />
                </div>
              )}
            </div>

            <button
              type="button"
              className={classes.deleteBtn}
              onClick={() => handleRemove(index)}
              disabled={values.length === 1 || disabled}
            >
              <TrashIcon className={classes.deleteBtn__img} />
            </button>
          </div>
        );
      })}

      <button
        type="button"
        className={classes.addBtn}
        onClick={handleAdd}
        disabled={disabled}
      >
        Add More
      </button>
    </div>
  );
};
